import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'via-infographics-modal',
  templateUrl: './infographics-modal.component.html',
  styleUrls: ['./infographics-modal.component.scss']
})
export class InfographicsModalComponent {

  constructor(
    public dialogRef: MatDialogRef<InfographicsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public infographicsName: string
  ) { }

  public closeModal(): void {
    this.dialogRef.close();
  }

}
